<ng-template #content_label_preview_settings let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.qr_label_gen">
        <div class="side_popup_header">
            <span>{{localService.languageContent.qr_label_gen.label_settings}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
    </div>
    <div class="side_popup_body" style="margin: 10px;padding: 10px;height: calc(100vh - 130px);"
        *ngIf="item && templates">
        <div *ngIf="templates.length == 0">
            <span>{{localService.languageContent.qr_label_gen.no_templates}}</span>
        </div>
        <div *ngIf="templates.length > 0">
            <div class="row" style="margin-bottom: 20px;">
                <div class="col-12">
                    <div>
                        <app-label [Text]="localService.languageContent.qr_label_gen.template" [IsMandatory]="true"
                            [isWrap]="true" />
                    </div>
                    <div>
                        <ngx-select [items]="templates" [optionValueField]="'key'" [optionTextField]="'value'"
                            placeholder="{{localService.languageContent.qr_label_gen.template}}" [(ngModel)]="item.v3"
                            [noAutoComplete]="true" [allowClear]="false" [disabled]="isSample || isUploadedData"
                            id="{{elementIds.template}}">
                        </ngx-select>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-bottom: 20px;"
                *ngIf="!isUploadedData && templateFor == QrLabelTemplateType.Product && expectedBusinessTypes">
                <div class="col-12">
                    <div>
                        <app-label [Text]="localService.languageContent.qr_label_gen.business_type" [IsMandatory]="true"
                            [isWrap]="true" />
                    </div>
                    <div>
                        <ngx-select [items]="expectedBusinessTypes" [optionValueField]="'key'"
                            [optionTextField]="'value'"
                            placeholder="{{localService.languageContent.qr_label_gen.business_type}}"
                            [(ngModel)]="item.v13" [noAutoComplete]="true" [allowClear]="false"
                            [disabled]="expectedBusinessTypes.length == 1" id="{{elementIds.business_type}}">
                        </ngx-select>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
                <div class="col-6">
                    <div>
                        <app-label [Text]="localService.languageContent.qr_label_gen.lbl_per_row" [isWrap]="true" />
                    </div>
                    <div>
                        <input autocomplete="off" type="number" class="number"
                            (keypress)="localService.isNumberOnly($event,numericConfigWithoutDecimal)"
                            id="{{elementIds.lbl_per_row}}" [(ngModel)]="item.v7" style="text-align: left;"
                            placeholder="{{localService.languageContent.qr_label_gen.lbl_per_row}}"
                            title="{{localService.languageContent.qr_label_gen.lbl_per_row}}"
                            [ngClass]="item.v7 ? 'en' : ''" />
                    </div>
                </div>
                <div class="col-6">
                    <div>
                        <app-label [Text]="localService.languageContent.qr_label_gen.start_column" [isWrap]="true" />
                    </div>
                    <div>
                        <input autocomplete="off" type="number" class="number"
                            (keypress)="localService.isNumberOnly($event,numericConfigWithoutDecimal)"
                            id="{{elementIds.start_column}}" [(ngModel)]="item.v9" style="text-align: left;"
                            placeholder="{{localService.languageContent.qr_label_gen.start_column}}"
                            title="{{localService.languageContent.qr_label_gen.start_column}}"
                            [ngClass]="item.v9 ? 'en' : ''" />
                    </div>
                </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
                <div class="col-6">
                    <div>
                        <app-label [Text]="localService.languageContent.qr_label_gen.paper_margin" [isWrap]="true" />
                    </div>
                    <div>
                        <input autocomplete="off" type="number" class="number"
                            (keypress)="localService.isNumberOnly($event,numericConfigWithoutDecimal)"
                            id="{{elementIds.paper_margin}}" [(ngModel)]="item.v8" style="text-align: left;"
                            placeholder="{{localService.languageContent.qr_label_gen.paper_margin}}"
                            title="{{localService.languageContent.qr_label_gen.paper_margin}}"
                            [ngClass]="item.v8 ? 'en' : ''" />
                    </div>
                </div>
                <div class="col-6">
                    <div>
                        <app-label [Text]="localService.languageContent.qr_label_gen.template_margin" [isWrap]="true" />
                    </div>
                    <div>
                        <input autocomplete="off" type="number" class="number"
                            (keypress)="localService.isNumberOnly($event,numericConfigWithoutDecimal)"
                            id="{{elementIds.template_margin}}" [(ngModel)]="item.v12" style="text-align: left;"
                            placeholder="{{localService.languageContent.qr_label_gen.template_margin}}"
                            title="{{localService.languageContent.qr_label_gen.template_margin}}"
                            [ngClass]="item.v12 ? 'en' : ''" />
                    </div>
                </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
                <div class="col-12">
                    <div>
                        <app-label [Text]="localService.languageContent.qr_label_gen.gaps" [isWrap]="true" />
                    </div>
                    <div>
                        <div class="row">
                            <div class="col-6">
                                <input autocomplete="off" type="number" class="number"
                                    (keypress)="localService.isNumberOnly($event,numericConfig)"
                                    id="{{elementIds.width}}" [(ngModel)]="item.v5" style="text-align: left;"
                                    placeholder="{{localService.languageContent.qr_label_gen.width}}"
                                    title="{{localService.languageContent.qr_label_gen.width}}"
                                    [ngClass]="item.v5 ? 'en' : ''" />
                            </div>
                            <div class="col-6">
                                <input autocomplete="off" type="number" class="number"
                                    (keypress)="localService.isNumberOnly($event,numericConfig)"
                                    id="{{elementIds.height}}" [(ngModel)]="item.v6" style="text-align: left;"
                                    placeholder="{{localService.languageContent.qr_label_gen.height}}"
                                    title="{{localService.languageContent.qr_label_gen.height}}"
                                    [ngClass]="item.v6 ? 'en' : ''" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
                <div class="col-6">
                    <div>
                        <app-label [Text]="localService.languageContent.qr_label_gen.template_radius" [isWrap]="true" />
                    </div>
                    <div>
                        <input autocomplete="off" type="number" class="number"
                            (keypress)="localService.isNumberOnly($event,numericConfigWithoutDecimal)"
                            id="{{elementIds.template_radius}}" [(ngModel)]="item.v10" style="text-align: left;"
                            placeholder="{{localService.languageContent.qr_label_gen.template_radius}}"
                            title="{{localService.languageContent.qr_label_gen.template_radius}}"
                            [ngClass]="item.v10 ? 'en' : ''" />
                    </div>
                </div>
                <div class="col-6">
                    <div>
                        <app-label [Text]="localService.languageContent.qr_label_gen.termplate_border_radius"
                            [isWrap]="true" />
                    </div>
                    <div>
                        <input autocomplete="off" type="number" class="number"
                            (keypress)="localService.isNumberOnly($event,numericConfigWithoutDecimal)"
                            id="{{elementIds.termplate_border_radius}}" [(ngModel)]="item.v11" style="text-align: left;"
                            placeholder="{{localService.languageContent.qr_label_gen.termplate_border_radius}}"
                            title="{{localService.languageContent.qr_label_gen.termplate_border_radius}}"
                            [ngClass]="item.v11 ? 'en' : ''" />
                    </div>
                </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
                <div class="col-6">
                    <div>
                        <app-label [Text]="localService.languageContent.qr_label_gen.copies" [isWrap]="true" />
                    </div>
                    <div>
                        <input autocomplete="off" type="number" class="number"
                            (keypress)="localService.isNumberOnly($event,numericConfigWithoutDecimal)"
                            id="{{elementIds.copies}}" [(ngModel)]="item.v4" style="text-align: left;"
                            placeholder="{{localService.languageContent.qr_label_gen.copies}}"
                            title="{{localService.languageContent.qr_label_gen.copies}}"
                            [ngClass]="item.v4 ? 'en' : ''" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label style="font-weight: normal; margin-left: 30px;">
                        <input type="checkbox" [(ngModel)]="item.isSelected" />
                        <span class="normal_color">{{localService.languageContent.qr_label_gen.is_border}}</span>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label style="font-weight: normal; margin-left: 30px;">
                        <input type="checkbox" [(ngModel)]="isSinglePrint" />
                        <span class="normal_color">{{localService.languageContent.qr_label_gen.single_print}}</span>
                    </label>
                </div>
            </div>
            <div class="dummy">
                &nbsp;
            </div>
        </div>
    </div>
    <div class="side_popup_footer">
        <div class="row">
            <div class="col-12" style="text-align: right;">
                <button id="{{elementIds.generate}}" type="button" class="btn btn-primary" (click)="onAction(1)">
                    {{localService.languageContent.qr_label_gen.generate}}
                </button>
            </div>
        </div>
    </div>
</ng-template>